import { createModule } from '../../createModule';
export const createBondsRecAPI = createModule(({ http }) => {
    return {
        getISINData: async (params) => {
            const res = await http.get('/v2/bonds_data_rec/isin-data-presence', {
                params,
            });
            return res;
        },
        getMissingEntries: async (params) => {
            const res = await http.get('/v2/bonds_data_rec/missing-entries', { params });
            return res;
        },
        getNotionaldiscrepancies: async (params) => {
            const res = await http.get('/v2/bonds_data_rec/notional-discrepancies', { params });
            return res;
        },
        getMissingYieldLock: async () => {
            const res = await http.get('/v2/bonds_data_rec/missing-yield-lock');
            return res;
        },
    };
});
